import img from "../media/undraw_interview_yz52 (1).svg"
import Footer from "../components/footer";
import "../css/screening.css"
import Navbar from "../components/nav";
import Swal from "sweetalert2";
import logo1 from "../media/whiteFav.png";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import useStore from "../store/zustandstore";
import { db } from "../firebase/firebase";
import { useEffect } from "react";
import usefbStore from "../store/firebasestore";
import { Icon } from "@iconify/react";
import { doc,updateDoc,getDocs,collection } from "firebase/firestore";

function Terms(){


    const navigate = useNavigate()
    const userID = usefbStore((s)=>s.userID)
    const setScreenCount =usefbStore((s)=>s.setScreenCount)
      const closeFonMenu = useStore((s)=> s.closeFonMenu)
        const fonMenuDrawer = useStore((s)=> s.fonMenuDrawer)
      

    const screenCount = usefbStore((s)=>s.screenCount)
    const hideScreenLoader= useStore((s)=>s.hideScreenLoader)
    useEffect(()=>{
     hideScreenLoader()      
    },[userID])
 
  const cnclFon = () =>{
    closeFonMenu();
  }

   const toAuth=()=>{

      navigate("/auth")
    }
     
   return (

    <section className="preScreen">
        <Helmet>
     <title>Terms of Service | Solara</title>
  <meta
    name="description"
    content="Read the terms and conditions governing your use of the Solara platform."
  />    
        </Helmet>
          <div className={`fonMenu ${fonMenuDrawer ? "fonMenuActive" : ""}`} >
        <img src={logo1} alt="" />
        <div className="sideMenuPlacer">
          <div className="fonMenuX" onClick={cnclFon}>
                
                <Icon className="faIcon" icon="solar:alt-arrow-right-linear" />
          </div>
          <div className="fonMenuLinks">

             <a href="/jobs">Job Opportunities</a>
             <a href="/dashboard">AI Tasks</a>
             <a href="/referral-program">Referral Program</a>
             <a href="/about">About Us</a>
            <button onClick={()=>toAuth()}>Get Started</button>
          </div>
          
        </div>
      </div>
        <div className="navContWhite navContWhiteLg">
                    <Navbar />
        </div>
        <div className="preScrenCont">
       <div className="preScreenImg">
             <h2>Terms of Service</h2>
        </div>
       
        <div className="preScreenCont">
<p> Our Terms of Service govern your access to and use of our website. By accessing
  or using our Services, you agree to be bound by these Terms and our  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
    Privacy Policy
  </a>. If you do not agree, you must discontinue use immediately.</p> 
 
<h3>Eligibility</h3>
<p>
You must be at least 18 years old or the age of majority in your jurisdiction to use our Services. By using the Platform, you represent and warrant that you meet these requirements.</p>

<h3> User Accounts</h3>
<p>To access certain features, you may be required to create an account. You agree to provide accurate, current, and complete information, maintain the confidentiality of your login credentials, accept responsibility for all activities under your account, and notify us immediately of any unauthorized access. We reserve the right to suspend or terminate accounts that violate these Terms or present security risks.</p>

<h3>User Responsibilities</h3>
<p>
You agree to use the Services lawfully and ethically. You must not engage in fraudulent, deceptive, or misleading activities, upload or distribute unlawful, harmful, or infringing content, interfere with or disrupt the integrity of the Platform, or attempt to manipulate job listings, payments, or system processes. Users handling client materials must respect confidentiality and data protection obligations.
</p>

<h3>Nature of the Platform</h3>
<p>Solara is a digital platform that connects freelancers with remote work opportunities. Solara offers a variety of work opportunities that may vary from time to time. We do not guarantee job placement, task availability, or income, and we do not act as a direct party to agreements between users. All work relationships are subject to the terms of the particular project.</p>
<h3>Client and Contractor Relationship</h3>
<p>Users who accept tasks or jobs through the Platform are subject to our work guidelines. You are solely responsible for your taxes, compliance, and legal obligations. Nothing in these Terms creates an employer-employee relationship, partnership, or joint venture.</p>
<h3>Payments and Compensation</h3>
<p>Compensation is based on task completion and acceptance criteria. Payment rates, structures, and timelines are defined per task or project, and tasks may be automatically rejected if they do not meet required standards. Solara reserves the right to withhold or adjust payments in cases of fraud, abuse, or policy violations and to delay payments pending verification or dispute review. Solara does not guarantee earnings, income levels, or availability of paid work.</p>
<h3>Fraud Prevention and Platform Integrity</h3>
<p>To maintain a safe ecosystem, Solara actively monitors for fake accounts, fraudulent activities, payment manipulation, abuse of task systems, and community conduct. We reserve the right to investigate suspicious behavior, suspend or permanently ban accounts, and take legal action where necessary. 
  
</p>
<ul>
  <li>
    <p> <b>Intellectual Property</b></p>
    <p>
       All content on the Platform, excluding user-generated content, is owned by Solara or its licensors. You may not copy, reproduce, or distribute platform content without permission. Users retain ownership of their submitted work but grant Solara a limited license to use it for platform operations.
The Services are provided on an "as is" and "as available" basis. We do not guarantee continuous or error-free access, accuracy of job listings, or reliability of third-party users. Use of the Platform is at your own risk.

    </p>
  </li>
  <li>
  <p><b> Limitation of Liability</b></p>  
    <p>
      To the fullest extent permitted by law, Solara shall not be liable for
      loss of income or business opportunities, disputes between users, user
      misconduct, or indirect, incidental, or consequential damages.
    </p>
  </li>

  <li>
  <p><b> Termination</b></p>
    <p>
      We may suspend or terminate your access at any time if you violate these
      Terms or if your activity poses risk to the Platform or its users. You
      may terminate your account at any time.
    </p>
  </li>

  <li>
  <p><b>Changes to Terms</b></p>
    <p>
      We may update these Terms periodically. Changes become effective upon
      posting. Continued use of the Platform after updates constitutes
      acceptance of the revised Terms.
    </p>
  </li>

  <li>
    <p><b>Contact Information</b></p>
    <p>
      For questions regarding these Terms, please contact us at <a href="mailto:admin@solarajobs.com">admin@solarajobs.com</a>.
    </p>
  </li>
</ul>

<p>
  By using Solara, you acknowledge that you have read, understood, and agreed
  to these Terms of Service.
</p>
        </div>

        </div>
 

      <Footer/>
        

    </section>
   )
}

export default Terms;